class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if( this.closest('#main-cart-items').dataset.id == 'cart-drawer') {

        this.closest('.cart-item__js').classList.add('d-none');
        this.closest('.cart-item').querySelector('.cart-undo__js').classList.remove('d-none');
        this.removeWithTimer = setTimeout(() => {
          this.closest('cart-items').updateQuantity(this.dataset.index, 0);
        }, 3000);
      } else {
        this.closest('cart-items').updateQuantity(this.dataset.index, 0);
      }

    });
    if( this.closest('#main-cart-items').dataset.id == 'cart-drawer') {
      this.closest('.cart-item').querySelector('.cart-undo__js').addEventListener('click',(event) => {
        event.preventDefault();
        this.closest('.cart-item').querySelector('.cart-item__js').classList.remove('d-none');
        this.closest('.cart-item').querySelector('.cart-undo__js').classList.add('d-none');
        clearTimeout(this.removeWithTimer);
      });
    }


  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class BestSellerAdd extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const parentDiv =  this.closest('[data-content="best-seller__js"]');
      let activeVid; 
      if( parentDiv.querySelector( 'select ') ) {
        // new custom setting for add
        activeVid = parentDiv.querySelector( 'select ').value;
      } else {
        activeVid = parentDiv.querySelector('.card-variants div.active').querySelector('a').dataset.variantId;
      }

      const cartItems = this.closest('cart-items');
      cartItems.querySelector('product-form').querySelector('[name="id"]').value = activeVid;
      cartItems.querySelector('product-form').querySelector('[type="submit"]').click();
    });
  }
}

customElements.define('best-seller-add', BestSellerAdd);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      if (!event.target.classList.contains("select__select")) {
        // your code
        this.onChange(event);
      } else {
        this.bestSellerSwatchesChange(event);
      }
    }, 300);
    if (document.querySelector(".cart-wrapper__js") != null) {
      this.querySelector("#cart-wrapper__js").addEventListener(
        "change",
        this.debouncedOnChange.bind(this)
      );
    } else {
      this.addEventListener("change", this.debouncedOnChange.bind(this));
    }
    // this.querySelector('#promoCode').removeEventListener('change', this.debouncedOnChange.bind(this));

    this.quantityInputs = this.querySelectorAll("quantity-input");
    this.CartSpecialInstructions = document.getElementById(
      "CartSpecialInstructions"
    );
    // Array.from(this.quantityInputs).forEach(element => {
    //   console.log('here am i')
    //   element.addEventListener('change',this.debouncedOnChange.bind(this))
    // });

    /**
     * Note settings
     */
    this.addNote();
    this.noteEvents();
    this.updateNotes();
    this.cartNoteCharacterCount();
    /**
     * Promo Code
     */
    this.promoClick();
    /**
     * Best Seller Slider
     */
    this.bestSellerSlider();
    this.setBestSellersPriority();
    this.showBestSellers();
  }

  bestSellerSlider() {
    const cartItems = document.querySelector("cart-items");
    if (cartItems.querySelectorAll(".card--recommended").length > 1) {
      new Swiper(".inline_recommendation_js", {
        loop: false,
        // autoHeight: true,
        allowTouchMove: true,
        spaceBetween: 10,
        slidesPerView: 1.25,
        pagination: {
          el: ".swiper-pagination-sm",
          clickable: true,
        },
      });
    }
  }
  setBestSellersPriority() {
    var $wrapper = $("#inlineCartRecommendation");
    $wrapper
      .find(".card")
      .sort(function (a, b) {
        return +a.dataset.priority - +b.dataset.priority;
      })
      .appendTo($wrapper);
  }
  showBestSellers() {
    if (document.getElementById("inlineCartRecommendation")) {
      var htmlstring = document.getElementById(
        "inlineCartRecommendation"
      ).innerHTML;
      htmlstring = htmlstring.trim
        ? htmlstring.trim()
        : htmlstring.replace(/^\s+/, "");
      if (htmlstring != "") {
        document
          .querySelector(".cart-recommendation--title-js")
          .classList.remove("d-none");
        document.querySelector("main").classList.add("has-you-may-like");
      } else {
        document
          .querySelector(".cart-recommendation--title-js")
          .classList.add("d-none");
        document.querySelector("main").classList.add("has-you-may-like");
      }
    }
  }
  promoClick() {
    let promoDiv = document.getElementById("promoCode");
    if (promoDiv) {
      promoDiv
        .querySelector(".add_promo__click")
        .addEventListener("click", (e) => {
          e.target.classList.toggle("d-none");
          promoDiv
            .querySelector(".promo-input__form")
            .classList.toggle("d-none");
        });
    }
  }

  addNote() {
    if (document.getElementById("note-checker")) {
      document.getElementById("note-checker").addEventListener("click", (e) => {
        var cartObj = {};
        let noteAttributes = {
          isGift: false,
        };
        if (e.target.checked) {
          noteAttributes = {
            isGift: true,
          };
        }
        cartObj["attributes"] = noteAttributes;
        fetch(`/cart/update.js`, {
          ...fetchConfig(),
          body: JSON.stringify(cartObj),
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            e.target
              .closest(".note-wrap")
              .querySelector("#addNodeBtn")
              .classList.toggle("d-none");
            e.target
              .closest(".note-wrap")
              .querySelector(".note-checker-icon")
              .classList.toggle("checked");
            if (
              !e.target
                .closest(".note-wrap")
                .querySelector(".note-checker-icon")
                .classList.contains("checked")
            ) {
              if (document.getElementById("cartPageNoteSubmit") != null) {
                document
                  .getElementById("cartPageNoteSubmit")
                  .classList.add("d-none");
                document.getElementById("checkout").classList.remove("d-none");
              }
            }
            if (document.querySelector(".cart__note--page")) {
              document
                .querySelector(".cart__note--page")
                .classList.add("is-hidden");
            }
          })
          .catch((error) => {
            console.log(error);
            this.querySelectorAll(".loading-overlay").forEach((overlay) =>
              overlay.classList.add("hidden")
            );
            document.getElementById("cart-errors").textContent =
              window.cartStrings.error;
            this.disableLoading();
          });
      });
    }
  }

  onChange(event) {
    if (
      !event.target.classList.contains("note-checker") &&
      event.target.closest("#cartnote") == null
    ) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name")
      );
    }
  }

  noteEvents() {
    this.addNodeBtn = document.getElementById("addNodeBtn");
    this.cartnote = document.getElementById("cartnote");
    this.noteChecker = document.getElementById("noteChecker");
    this.promoCode = document.getElementById("promoCode");
    this.closeNoteData = document.querySelectorAll(".close_note_js");
    this.cartPageNoteSubmit = document.getElementById("cartPageNoteSubmit");
    this.checkoutBtn = document.getElementById("checkout");
    this.openNote();
    this.closeNote();
  }

  openNote() {
    if (this.addNodeBtn != null) {
      this.addNodeBtn.addEventListener("click", (event) => {
        this.cartnote.classList.remove("is-hidden");
        if (this.cartPageNoteSubmit != null) {
          this.cartPageNoteSubmit.classList.remove("d-none");
          this.checkoutBtn.classList.add("d-none");
        }
        if (this.noteChecker) {
          this.noteChecker.classList.remove("icon-square");
        }
        // this.noteChecker.classList.add('icon-square-tick');
      });
    }
  }
  closeNote() {
    this.closeNoteData.forEach((element) => {
      element.removeEventListener("click", this.noteClosed);
      element.addEventListener("click", this.noteClosed);
    });
  }
  noteClosed() {
    document.getElementById("cartnote").classList.add("is-hidden");
  }

  getSectionsToRender() {
    if (document.querySelector("#cart-wrapper__js") != null) {
      return [
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".js-contents",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
        {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section",
        },
        {
          id: "cartHeadingNotice",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".js-content",
        },
        {
          id: "cart-count_js",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".c-cart-title-count",
        },
      ];
    } else {
      return [
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".js-contents",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
        {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section",
        },
        {
          id: "main-cart-footer",
          section: document.getElementById("main-cart-footer").dataset.id,
          selector: ".js-contents",
        },
        {
          id: "cart-recommendation__js",
          section: document.getElementById("cart-recommendation__js").dataset
            .id,
          selector: ".inline-recommendation",
        },
      ];
    }
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");
        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (document.querySelector("#cart-wrapper__js") != null) {
          const cartImage = document.getElementById("cartImage");
          const cardBody = this.querySelector("#cardBody");
          if (cartImage)
            cartImage.classList.toggle(
              "is-empty",
              parsedState.item_count === 0
            );
          if (cardBody)
            cardBody.classList.toggle("is-empty", parsedState.item_count === 0);
          setTimeout(() => {
            this.noteEvents();
            this.addNote();
          }, 1000);
          this.querySelector("#cart-wrapper__js").addEventListener(
            "change",
            this.debouncedOnChange.bind(this)
          );
        }
        const bestSellers = document.getElementById("cart-recommendation__js");
        if (bestSellers)
          bestSellers.classList.toggle("d-none", parsedState.item_count === 0);
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
        this.bestSellerSwatches();
        this.bestSellerSlider();
        this.setBestSellersPriority();
        this.showBestSellers();
        if (document.querySelector("#cart-wrapper__js") != null) {
          this.updateCartHeight();
        }
      })
      .catch((error) => {
        console.log(error);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error;
        this.disableLoading();
      });
  }

  addBestSeller(id, quantity) {
    // this.enableLoading(line);
    //sections: cart-notification-product,cart-notification-button,cart-icon-bubble,cart-drawer
    // sections_url: /products/the-chair
    const cartNotification = document.querySelector("cart-notification");
    const body = JSON.stringify({
      id,
      quantity,
      sections: cartNotification
        .getSectionsToRender()
        .map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        cartNotification.renderContents(response);
        // const parsedState = JSON.parse(state);
        // this.classList.toggle('is-empty', parsedState.item_count === 0);
        // const cartFooter = document.getElementById('main-cart-footer');
        // if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        // if(document.querySelector('#cart-wrapper__js') != null) {
        //   const cartImage = document.getElementById('cartImage');
        //   const cardBody = this.querySelector('#cardBody');
        //   if (cartImage) cartImage.classList.toggle('is-empty', parsedState.item_count === 0);
        //   if (cardBody) cardBody.classList.toggle('is-empty', parsedState.item_count === 0);
        //   this.noteEvents();
        this.addNote();
        //   this.querySelector('#cart-wrapper__js').addEventListener('change', this.debouncedOnChange.bind(this));
        // }
        // this.getSectionsToRender().forEach((section => {
        //   const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        //   elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        // }));
        // this.updateLiveRegions(line, parsedState.item_count);
        // const lineItem = document.getElementById(`CartItem-${line}`);
        // if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        // this.disableLoading();
        // this.updateCartHeight();
        // this.bestSeller();
      })
      .catch((error) => {
        console.log(error);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateCartHeight() {
    // console.log('update cart height')
    if (document.querySelector(".c-cart-top-content") != null) {
      const titleheight = document.querySelector(
        ".c-cart-top-content"
      ).offsetHeight;
      const footerheight = document.querySelector(
        ".c-cart-shipping__col "
      ).offsetHeight;
      const screenHeight = window.innerHeight;
      document
        .querySelector(".cart-you-may-like-wrap")
        .setAttribute(
          "style",
          `height:${screenHeight - titleheight - footerheight - 32}px`
        );
    }
  }

  bestSellerSwatches() {
    var colorSwatches = document.querySelectorAll(
      ".thumb-product-card__js .color-swatches a"
    );
    colorSwatches.forEach((swatch) => {
      swatch.addEventListener("click", (event) => {
        const currentTarget = event.currentTarget,
          clickedVariantId = currentTarget.getAttribute("data-variant-id"),
          parentDiv = currentTarget.closest(".thumb-product-card__js"),
          swatchesList = parentDiv.querySelectorAll(".swatch"),
          varitantImages = parentDiv.querySelectorAll(
            ".thumb-product-card-images img"
          ),
          salePrice = currentTarget.dataset.price,
          regularPrice = currentTarget.dataset.regularPrice;
        swatchesList.forEach((item) => {
          item.classList.remove("active");
        });

        parentDiv.querySelector(".price-item--sale").innerHTML = salePrice;
        parentDiv.querySelector(".price__sale .text-link s").innerHTML =
          regularPrice;

        currentTarget.parentNode.classList.add("active");
        varitantImages.forEach((image) => {
          const imageVariantId = image.getAttribute("data-variant-id");
          if (clickedVariantId === imageVariantId) {
            image.classList.add("show");
            image.classList.remove("d-none");
          } else {
            image.classList.add("d-none");
          }
        });
      });
    });
  }
  bestSellerSwatchesChange(event) {
    let currentTarget = event.currentTarget
      ? event.currentTarget
      : event.target;

    const clickedVariantId = currentTarget.value,
      parentDiv = currentTarget.closest(".thumb-product-card__js"),
      varitantImages = parentDiv.querySelectorAll(
        ".thumb-product-card-images img"
      ),
      salePrice =
        event.target.options[event.target.selectedIndex].dataset.price,
      regularPrice =
        event.target.options[event.target.selectedIndex].dataset.regularPrice;

    parentDiv.querySelector(".price-item--sale").innerHTML = salePrice;
    parentDiv.querySelector(".price__sale .text-link s").innerHTML =
      regularPrice;

    varitantImages.forEach((image) => {
      const imageVariantId = image.getAttribute("data-variant-id");
      if (clickedVariantId === imageVariantId) {
        image.classList.add("show");
        image.classList.remove("d-none");
      } else {
        image.classList.add("d-none");
      }
    });
  }

  updateNotesEvent(skip = false) {
    var cartObj = {};
    var attributes = {
      sender_name: null,
      receiver_name: null,
      receiver_email: null,
      message: null,
      "item_[1]_name": null,
      "item_[0]_name": null,
      "item_[1]": null,
      "item_[0]": null,
      reciever_name: null,
      reciever_email: null,
      optional_message: null,
    };
    if (!skip) {
      const cartForm = document.getElementById("cart");
      const sender_name = document.getElementById("yourName").value;
      const receiver_name = document.getElementById("theirName").value;
      const receiver_email = document.getElementById("theirEmail").value;
      const optional_message = document.getElementById(
        "CartSpecialInstructions"
      ).value;
      attributes = {
        sender_name: `${sender_name}`,
        receiver_name: `${receiver_name}`,
        receiver_email: `${receiver_email}`,
        message: `${optional_message}`,
        "item_[1]_name": null,
        "item_[0]_name": null,
        "item_[1]": null,
        "item_[0]": null,
        reciever_name: null,
        reciever_email: null,
        optional_message: null,
      };
    }
    cartObj["attributes"] = attributes;

    fetch(`/cart/update.js`, {
      ...fetchConfig(),
      body: JSON.stringify(cartObj),
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        // const parsedState = JSON.parse(state);
        window.location.href = "/checkout";
      })
      .catch((error) => {
        console.log(error);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateNotes() {
    let cartPageNoteSubmit = document.getElementById("cartPageNoteSubmit");
    if (cartPageNoteSubmit != null) {
      cartPageNoteSubmit.addEventListener("click", () => {
        this.updateNotesEvent();
      });
    }

    let noteSubmit = document.getElementById("noteSubmit");
    if (noteSubmit != null) {
      noteSubmit.addEventListener("click", () => {
        this.updateNotesEvent();
      });
    }

    let skipNote = document.getElementById("skipNote");
    if (skipNote != null) {
      skipNote.addEventListener("click", () => {
        this.updateNotesEvent(true);
      });
    }

    if (this.CartSpecialInstructions != null) {
      this.CartSpecialInstructions.addEventListener("keyup", () => {
        this.cartNoteCharacterCount();
      });
    }
  }

  cartNoteCharacterCount() {
    if (document.getElementById("noteWordLimit") != null) {
      document.getElementById("noteWordLimit").querySelector("span").innerHTML =
        this.CartSpecialInstructions.value.length;
    }
  }

  updateLiveRegions(line, itemCount) {
    // console.log(this.currentItemCount)
    // console.log('itemCount',itemCount)
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
      const cartForm = document.getElementById("cart");
      cartForm.addEventListener("submit", () => {
        document
          .getElementById("drawer-loader")
          .classList.remove("is-hidden-loader__js");
      });
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document
      .getElementById("main-cart-items")
      .classList.add("cart__items--disabled");
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
      (overlay) => overlay.classList.remove("hidden")
    );
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    document
      .getElementById("main-cart-items")
      .classList.remove("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);

setTimeout(() => {
  if (document.querySelector(".c-cart-top-content")) {
    var titleheight = document.querySelector(
      ".c-cart-top-content"
    ).offsetHeight;
    var footerheight = document.querySelector(
      ".c-cart-shipping__col "
    ).offsetHeight;
    var screenHeight = window.innerHeight;
    document
      .querySelector(".cart-you-may-like-wrap")
      .setAttribute(
        "style",
        `height:${screenHeight - titleheight - footerheight - 32}px`
      );
  }
  // console.log(titleheight);
  // console.log(footerheight);
}, 1000);
